import Vue from 'vue'
import { decode } from 'utils/general'
import Cookies from 'js-cookie'

Vue.component('cookies-notice', {
  props: ['delay', 'title', 'content'],
  data () {
    return {
      showing: false
    }
  },
  mounted () {
    const delay = parseInt(this.delay)
    setTimeout(() => {
      this.showing = !Cookies.get('cookiesNotice')
    }, delay)
  },
  computed: {
    richtextContent () {
      return decode(this.content)
    }
  },
  methods: {
    close () {
      Cookies.set('cookiesNotice', 'closed', { expires: 7 })
      this.showing = false
    }
  }
})
